import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './styles.module.scss'

const SectionWithImage = ({ children, className }) => {
  return (
    <div className={cx(styles.section, className)}>
      {children}
    </div>
  )
}

SectionWithImage.propTypes = {
  className: PropTypes.string,
}

SectionWithImage.defaultProps = {
  className: null,
}

export default SectionWithImage
